import styled from 'styled-components';

export default styled.div`
  flex: 1;
  background: ${(props) => props.theme.colors.snow};
`;
